module.exports = __webpack_public_path__ + "img/1 (101).d63b87a3.png";